export const readFileAsBase64 = file => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            resolve(result.substr(result.indexOf(",") + 1));
        };
        reader.readAsDataURL(file);
    });
};